import { ErrorSmallPopup } from '../../popups/errorSmallPopup';
import { Localization } from '../../localization/localization';
import { Tethers } from '../../accounts/tethers';
import { CurrentUser } from '../../general/modules/user/currentUser';
import { switchCurrentAccount } from '../../accounts/switch-current-account';

type SwitchCurrentCharacterParams = {
    suid: string
};


export class SwitchCurrentCharacter {
    public async handle(_data: SwitchCurrentCharacterParams) {
        const currentUser = CurrentUser.getInstance();
        const linkedAccounts = await Tethers.getLinkedAccountsInfo(
            currentUser.getSuid().toString(),
            currentUser.getAuthToken()
        );

        if ('error' in linkedAccounts) {
            showSwitchErrorPopup(Localization._n('common_error'));
            throw new Error('Failed to get linked accounts');
        }

        const targetAccount = linkedAccounts.tethers?.find((account) => account.suid === _data.suid);

        if (!targetAccount) {
            showSwitchErrorPopup(Localization._n('common_error'));
            throw new Error('Suid not owned');
        }

        switchCurrentAccount(targetAccount, _data.suid);
    }
}

function showSwitchErrorPopup(message: string): void {
    const errorSmallPopup = ErrorSmallPopup.getInstance();
    errorSmallPopup.setMessage(message);
    errorSmallPopup.setButtonText(Localization._n('ecommpay.button_to_retry'));
    errorSmallPopup.show();
    errorSmallPopup.setCallback(() => {
        errorSmallPopup.hide();
    });
}

